window.onload = function () {
  /**
   * 设置登录页图片大小
   *
   * @param[target] Object dom对象
   * @param[imgSize] {} 图片大小
   * */
  /*const setLogoImgAttr = (target, imgSize) => {
    //  780*1240
    imgSize = imgSize || {
      width: 780,
      height: 1240,
    };
    target = target || imgSize;
    const style = {
      opacity: 1,

    };
    const img_height = target.width / imgSize.width * imgSize.height;
    style.height = img_height > window.innerHeight ? `${img_height}px` : `${window.innerHeight}px`;
    console.log(target);
    console.log(target.width);
    console.log(target.height);
    console.log(style);

    return style
  };*/

  /** ===================================
   * @names：登录页
   * @author：jisen
   * @time：2021-11-19
   * @description：
   * ==============================================*/
	new Vue({
	el: '#app',
	i18n,
	mixins: [mixin],
	data() {
		return {
		timer: null,
		submitting: false,
		imgStyle: {},
		formData: {
			// 用户名
			userName: '',
			// 密码
			password: '',
			// token 键值
			tokenName: '',
			// token
			token: '',
			// 十天免登录
			freeLogin: false,
			//
			ssoUserName: '',
			//
			ssoIdpId: undefined
		},
		res_tips: {
			type: '',
			message: '',
		},
		loginType: 'account',
		ssoListData: []
		};
	},
	methods: {
			/**
			 * 加密
			 * @param encryptString 要加密的字符串
			 * @param key 秘钥
			 * @returns {string} 加密后的字符串
			 */
			aesEncrypt(encryptString, key) {
				var _key = CryptoJS.enc.Utf8.parse(key);
				var srcs = CryptoJS.enc.Utf8.parse(encryptString);
				var encrypted = CryptoJS.AES.encrypt(srcs, _key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
				return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
			},

			/**
			 * 解密
			 * @param decryptString 要解密的字符串
			 * @param key 秘钥
			 * @returns {string} 解密后的字符串
			 */
			/*aesDecrypt(decryptString, key) {
				var _key = CryptoJS.enc.Utf8.parse(key);
				var srcs = CryptoJS.enc.Hex.parse(decryptString);
				srcs = CryptoJS.enc.Base64.stringify(srcs);
				var decrypt = CryptoJS.AES.decrypt(srcs, _key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
				//返回解密结果
				return decrypt.toString(CryptoJS.enc.Utf8);
			}*/

			/**
			 * 判断密码是否合法  合法字符集，字符范围为ascll的[33, 126]
			 * @param password 密码
			 * @returns {boolean} 是否合法密码
			 */
			checkPassword(password) {
				let flag = true;
				for(let char of password){
					let code = char.charCodeAt();
					if (code < 33 || code > 126 ) {
						flag = false;
					}
				}
				return flag;
			},

			// 提交表单数据
			submitForm() {
				const isLogin = localStorage.getItem('loginStatus');
				if(isLogin === 'login') {
					window.location.reload(); // 刷新页面
				} else {
					const { userName, password, token, tokenName } = this.formData;
					// 校验密码是否在限定范围内
					/*if (!this.checkPassword(password)) {
						this.res_tips = {
							type: 'error',
							message: this.$i18n.t('page.login.form.password.illegal'),
						};
						return false;
					}*/
					if (!userName.trim()) {
						this.res_tips = {
							type: 'error',
							message: this.$i18n.t('page.login.form.userName.required'),
						};
						return false;
					}
					if (!password.trim()) {
						this.res_tips = {
							type: 'error',
							message: this.$i18n.t('page.login.form.password.required'),
						};
						return false;
					}
					/* const params = {
						 username: userName,
						 // password: password
						 // _csrf: 44d251a4-e5d4-4a23-bc7c-f24d34c14863
						 // submit: 登录
						 password: Base64.encode(password),
					 };
					 params[tokenName] = token;*/
					const params = [
						{
							key: 'username',
							value: userName,
						},
						{
							key: 'password',
							// value: Base64.encode(password.replace(/\s*/g,"")),//Base64加密
							value: this.aesEncrypt(password.replace(/\s*/g,""), 'i1kjJoIlKOe$0*X$'),//AES Hex加密
						},
						{
							key: 'from',
							value: 'yun',
						},
					];
					tokenName && params.push({
						key: tokenName,
						value: token,
					});
					this.submitting = true;

					localStorage.setItem('loginStatus', 'login');
					utilsSubmitForm({
						url: window.submitUrl,
						params,
					});
				}
			},
			// 提交表单数据
			ssoSubmitForm() {
				// const isLogin = localStorage.getItem('loginStatus');
				// if(isLogin === 'login') {
				// 	window.location.reload(); // 刷新页面
				// } else {
					const { ssoUserName, ssoIdpId } = this.formData;
					if (!ssoUserName.trim()) {
						this.res_tips = {
							type: 'error',
							message: this.$i18n.t('page.login.form.ssoUserName.required'),
						};
						return false;
					}
					if (!ssoIdpId) {
						this.res_tips = {
							type: 'error',
							message: this.$i18n.t('page.login.form.ssoIdpId.required'),
						};
						return false;
					}
					const {id} = this.ssoListData.find(item => item?.id === ssoIdpId)
					if (id) {
						// const params = [
						// 	{
						// 		key: 'idpConfIdentifier',
						// 		value: id,
						// 	}
						// ];
						const params = {
							idpConfIdentifier: id
						}
						this.submitting = true;

						// localStorage.setItem('loginStatus', 'login');
						// utilsSubmitForm({
						// 	url: '/auth/sso/sso-login',
						// 	params,
						// });
						httpPostSsoLogin(params).then(res => {
							this.submitting = false;
							if (res?.code === '20000' && res?.data) {
								window.location.href = res.data;
							} else {
								if (res?.message) {
									this.res_tips = {
										type: 'error',
										message: res.message,
									};
								}
							}
						})
					}
				// }
			},
			// 设置图片属性
			/*handleSetLogoImgAttr() {
				const dom_img = this.$refs['imgLogo'];
				this.imgStyle = setLogoImgAttr(dom_img);
				window.addEventListener("resize", () => {
					console.log('resize');
					// 防止运行两次
					clearTimeout(this.timer);
					this.timer = setTimeout(() => {
						this.imgStyle = setLogoImgAttr(dom_img)
					}, 300);
				}, false);

				window.addEventListener("pageshow", (e) => {
					console.log(e);
					// 浏览器后退的时候从新计算
					if (e.persisted) {
						clearTimeout(this.timer);
						this.timer = setTimeout(() => {
							console.log('pageshow');
							this.imgStyle = setLogoImgAttr(dom_img)
						}, 300);
					}
				}, false);
			},*/
			// 监听localStorage状态
			handleStorageChange(event) {
				if (event.key === 'loginStatus' && event.newValue === 'login') {
					setTimeout(() => {
							window.location.reload(); // 刷新页面
					}, 3000);
				}
			},
			// 获取ssoListData
			getSsoListData(val) {
				httpGetUserIdpConf({
					username: val,
				}).then(res => {
					this.ssoListData = res?.data || []
				})
			},
			handleChangeLoginType(type){
				this.loginType = type;
				this.res_tips.type = '';
				sessionStorage.setItem('loginType', type);
			}
		},
		watch: {
			'formData.userName'(val) {
				console.log(val);
				this.res_tips.type = '';
			},
			'formData.password'(val) {
				console.log(val);
				this.res_tips.type = '';
			},
			'formData.ssoUserName': debounce(function (val) {
				this.res_tips.type = '';
				this.formData.ssoIdpId = undefined;
				this.ssoListData = [];
				this.getSsoListData(val);
			}, 500),
			'formData.ssoIdpId'(val) {
				console.log(val);
				this.res_tips.type = '';
			},
		},
		computed: {
			setLanguageBtnName() {
				return (i18n.locale === 'en') ? '中 文' : 'English'
			},
			formDisabled() {
				return this.submitting
			},
		},
		beforeMount() {
			// const error = getUrlParam('error');
			const error = window.error;
			if (error === 'failure') {
				console.log(error);
				this.res_tips = {
					type: 'error',
					message: window.errorMessage || this.$i18n.t('page.login.error'),
					// message: '用户名或密码错误',
				}
			}
			if (window.token && window.tokenName) {
				// JSP 参数
				this.formData.token = window.token;
				this.formData.tokenName = window.tokenName;
			}
		},
		beforeCreate() {
			if(window.loginLinkUrl) {
				window.location.href = window.loginLinkUrl;
			}
			localStorage.setItem('loginStatus', 'logout');
			setHtmlTitle(this.$i18n.t('page.login.title'));
		},
		created() {
			if (sessionStorage.getItem('loginType')) {
				this.loginType = sessionStorage.getItem('loginType');
			}
		},
		mounted() {
			// 登录按钮绑定回车事件
			window.document.onkeyup = e => {
				console.log(e);
				const { keyCode } = e || {};
				if (keyCode === 13) {
					this.submitForm();
				}
			};
			window.addEventListener('storage', this.handleStorageChange);
			// this.handleSetLogoImgAttr();
		},
		beforeDestroy() {
			window.removeEventListener('storage', this.handleStorageChange);
		},
	});
};
